module.exports = __webpack_public_path__ + "img/Syg_icon_sdfdssd.b8c9550c.png";